export default "__VITE_ASSET__59f22ee9__"